import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  ArrowLeft,
  Check,
  Copy,
  Share2,
  FileText,
  Clock,
  Info,
  Link as LinkIcon,
} from "lucide-react";
import { imgNbaLogo } from "../../../../assets";

export default function KYCSuccess() {
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);

  // In a real app, these would come from state/context/params
  const paymentLink = "https://nba.synclexs.com/rece23....";
  const invoiceNumber = "#INV - 2401";
  const amountDue = 5000000;
  const propertyAddress = "Plot 45, Lekki Phase 1";
  const propertyFingerprint =
    "a7f3c9e2b8d4f6a1c5e8b9d2f4a6c8e1b3d5f7a9c2e4b6d8f1a3c5e7b9d2f4a6";

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(paymentLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  const handleDone = () => {
    navigate("/d");
  };

  return (
    <div className="kyc-page">
      <div className="kyc-header">
        <div className="kyc-logo-section">
          <img className="kyc-logo-img" src={imgNbaLogo} alt="NBA Logo" />
          <div className="kyc-logo-text">
            <div className="kyc-logo-name">NIGERIAN BAR ASSOCIATION</div>
            <div className="kyc-logo-sub">REMUNERATION PORTAL</div>
          </div>
        </div>
      </div>

      <div className="kyc-container">
        <div className="kyc-content">
          <div className="kyc-success-badge">
            <Check size={20} />
            <span>Transaction Created</span>
          </div>

          <div className="kyc-section-header">
            <h1 className="kyc-title">Payment Link Ready</h1>
            <p className="kyc-subtitle">
              Share the secure payment link with your client to complete the
              invoice payment
            </p>
          </div>

          <div className="kyc-invoice-card">
            <div className="kyc-invoice-header">
              <div className="kyc-invoice-title-section">
                <FileText size={20} />
                <span className="kyc-invoice-title">INVOICE TO CLIENT</span>
              </div>
              <div className="kyc-invoice-number">{invoiceNumber}</div>
            </div>

            <div className="kyc-invoice-amount">
              <div className="kyc-invoice-amount-section">
                <span className="kyc-invoice-amount-label">AMOUNT DUE</span>
                <span className="kyc-invoice-amount-value">
                  ₦{amountDue.toLocaleString()}
                </span>
              </div>
              <p className="kyc-invoice-amount-desc">Professional Fee</p>
            </div>

            <div className="kyc-invoice-details">
              <div className="kyc-invoice-detail-row">
                <span className="kyc-invoice-detail-label">Property</span>
                <span className="kyc-invoice-detail-value">
                  {propertyAddress}
                </span>
              </div>
              <div className="kyc-invoice-divider" />
              <div className="kyc-invoice-detail-row">
                <span className="kyc-invoice-detail-label">Due Date</span>
                <span className="kyc-invoice-detail-value">
                  30 days from now
                </span>
              </div>
            </div>

            <div className="kyc-payment-link-section">
              <div className="kyc-payment-link-header">
                <LinkIcon size={18} />
                <span className="kyc-payment-link-title">
                  SECURE PAYMENT LINK
                </span>
              </div>

              <div className="kyc-payment-link-wrapper">
                <div className="kyc-payment-link-input">
                  <span>{paymentLink}</span>
                </div>
                <button
                  className="kyc-copy-button"
                  type="button"
                  onClick={handleCopy}
                >
                  <Copy size={16} />
                  <span>{copied ? "Copied!" : "Copy"}</span>
                </button>
              </div>

              <button className="kyc-share-button" type="button">
                <Share2 size={18} />
                <span>Share invoice link</span>
              </button>

              <p className="kyc-payment-link-note">
                Send this link to your client to pay the ₦
                {amountDue.toLocaleString()} invoice securely
              </p>
            </div>
          </div>

          <div className="kyc-fingerprint-section">
            <div className="kyc-fingerprint-header">
              <div className="kyc-fingerprint-title-section">
                <span className="kyc-fingerprint-title">
                  PROPERTY FINGERPRINT
                </span>
              </div>
              <div className="kyc-verified-badge">
                <Check size={14} />
                <span>VERIFIED</span>
              </div>
            </div>
            <div className="kyc-fingerprint-value">{propertyFingerprint}</div>
            <p className="kyc-fingerprint-desc">
              Cryptographic hash uniquely identifies this property of the
              blockchain
            </p>
          </div>

          <div className="kyc-status-section">
            <Clock size={20} />
            <div className="kyc-status-content">
              <span className="kyc-status-label">CURRENT STATUS</span>
              <p className="kyc-status-text">
                Certificate Pending – Will be issued upon payment confirmation
              </p>
            </div>
          </div>

          <div className="kyc-summary-link">
            <FileText size={20} />
            <div className="kyc-summary-link-content">
              <span className="kyc-summary-link-title">
                View Provisional Summary
              </span>
              <span className="kyc-summary-link-subtitle">
                Preview transaction details and timeline
              </span>
            </div>
            <ArrowLeft size={18} className="kyc-summary-link-arrow" />
          </div>

          <div className="kyc-info-box kyc-info-box--with-icon">
            <Info size={20} />
            <p>
              You'll receive email notifications for payment confirmation and
              certificate issuance. Client can pay via card, bank transfer, or
              USSD.
            </p>
          </div>

          <button
            className="dashboard-button dashboard-button--primary dashboard-button--large"
            type="button"
            onClick={handleDone}
          >
            <Check size={18} />
            <span>Done</span>
          </button>
        </div>
      </div>
    </div>
  );
}
